// DisclaimerPage.js
import React from "react";
import { Default } from "../layouts/default";
import { Link } from "react-router-dom";
import "../../css/DisclaimerPage.css";

const DisclaimerPage = () => {
  return (
    <Default>
      <div className="disclaimer-page">
        <div className="disclaimer-container">
          <h1 className="disclaimer-title">Disclaimer </h1>

          {/* <p className="effective-date">
            <strong>Effective Date:</strong> [Add Date]
          </p> */}

          <p className="intro-text">
            BookVenue is an online sports venue booking platform.
          </p>

          <section className="disclaimer-section">
            <ul className="steps">
              <li>
                We do not own or operate the venues listed on the platform
              </li>
              <li>
                We are not responsible for venue availability, quality, or
                services
              </li>
              <li>
                Users are advised to verify details before making a booking
              </li>
              <li>
                While we aim to provide accurate and updated information, we do
                not guarantee completeness or reliability.
              </li>
              <li>Use of the platform is at your own risk.</li>
            </ul>
          </section>

          <section className="disclaimer-section contact-section">
            <h2>Contact</h2>
            <p>
              For any queries, email:
              <Link to="mailto:admin@bookvenue.app">admin@bookvenue.app</Link>
            </p>
            <p>
              Mob No:
              <Link to="tel:+9175008720134">+91-7500872014</Link>
            </p>
          </section>
        </div>
      </div>
    </Default>
  );
};

export default DisclaimerPage;
